import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LexTranslateService } from '@app/core/services/lex-translate.service';
interface DialogData {
  icon: string
  title: string
  paragraph: string
  question: string
}
@Component({
  selector: 'seb-information-dialog',
  templateUrl: './information-dialog.component.html',
  styleUrls: ['./information-dialog.component.css']
})
export class InformationDialogComponent {
  constructor(
    public lextranslate: LexTranslateService, 
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }


}
